import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { Subject, takeUntil } from 'rxjs';
import { Mousewheel, Swiper } from 'swiper';

@Component({
  selector: 'app-listing-swiper',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './listing-swiper.component.html',
  styleUrl: './listing-swiper.component.css',
})
export class ListingSwiperComponent implements OnInit, OnDestroy {
  lang: string = '';
  swiperItems = [
    {
      title: 'sell-with-us.listing-swiper-section.slide01.title',
      description: 'sell-with-us.listing-swiper-section.slide01.description',
    },
    {
      title: 'sell-with-us.listing-swiper-section.slide02.title',
      description: 'sell-with-us.listing-swiper-section.slide02.description',
    },
    {
      title: 'sell-with-us.listing-swiper-section.slide03.title',
      description: 'sell-with-us.listing-swiper-section.slide03.description',
    },
    {
      title: 'sell-with-us.listing-swiper-section.slide04.title',
      description: 'sell-with-us.listing-swiper-section.slide04.description',
    },
  ];

  private translocoService = inject(TranslocoService);
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    const swiper = new Swiper('.swiper', {
      direction: 'vertical',
      slidesPerView: 1,
      spaceBetween: 30,
      // autoplay: {
      //   delay: 4000,
      //   disableOnInteraction: false,
      // },
      modules: [Mousewheel],
      mousewheel: {
        releaseOnEdges: true,
      },
      touchReleaseOnEdges: true,
    });

    this.translocoService.langChanges$
      .pipe(takeUntil(this.destroy$))
      .subscribe((lang: string) => {
        this.lang = lang;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
